import {z} from '@hono/zod-openapi';

export const automarketplEquipmentCatalogueRequestSchema = z
  .object({
    eurotaxCode: z.number().int().safe().positive().openapi({example: 113917}),
    registrationDate: z.string().date().openapi({example: '2019-08-30'}),
  })
  .strict()
  .openapi('AutomarketplEquipmentCatalogueRequest');

export type AutomarketplEquipmentCatalogueRequest = z.infer<
  typeof automarketplEquipmentCatalogueRequestSchema
>;
